import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CaminoService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.baseUrl}/camino`,{params:searchParams});
    }

    get(deviceId){
      return this.http.get(`${environment.baseUrl}/camino/`+deviceId);
    }

    edit(deviceId,formData){
      return this.http.put(`${environment.baseUrl}/camino/`+deviceId,formData);
    }

    create(formData){
      return this.http.post(`${environment.baseUrl}/camino`,formData);
    }

    delete(deviceId){
      return this.http.delete(`${environment.baseUrl}/camino/`+deviceId);
    }

}
